module.exports = __webpack_public_path__ + "static/media/badge9.2cb750f9.svg";